export const getJsonObject = (object) => {
  if (typeof object === 'string') {
    return JSON.parse(object.trim())
  }
  return object
}
